export enum StorageKeys {
  EXPANDED = 'expanded'
}
